import React, { Component } from 'react';
import { Descriptions, Tabs, Table, Pagination, Form, Button, Select, notification } from 'antd';
import { post } from '../../utils/http';
import api from '../../utils/api';
import { sessionManager } from '../../core/SessionManager';

const { TabPane } = Tabs;

class CounterMgt extends Component {
    constructor(props) {
        super(props)
        this.state = {
            total: 0,
            allNum: 0,
            activeNum: 0,
            data: [],
            tabData: 'All',
            loading: false,
            selectedRowKeys: [],
        }
    }

    handleChangeTab = (key) => {
        this.setState({ tabData: key }, () => {
            this.handleSearch()
        });
    };

    handleSearch = () => {
        this.setState({ loading: true })
        let { tabData } = this.state;
        let detailId = sessionManager.getMerchantId();
        let searchData = { tabData, detailId };
        var _this = this;
        post(api.getCounterList, searchData).then(function (response) {
            let { counterList, activeNum, total } = response;
            _this.setState({
                loading: false,
                data: counterList,
                total: counterList.length,
                activeNum,
                allNum: total
            })
        }).catch(function (error) {
            console.log(error)
            _this.setState({ loading: false })
            
            notification['error']({
                message: error.errmsg,
            });
        })
    }

    componentWillMount() {
        this.handleSearch()
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys })
    }

    columns = [{
        dataIndex: 'counterAlias',
        title: 'Counter Code',
        width: 170,
    }, {
        dataIndex: 'owner',
        title: 'Outlet Name',
        width: 170,
    }, {
        dataIndex: 'status',
        title: 'Status',
        width: 170,
        align: 'center',
        render: text => {
            if (text === 0 || text === 3) {
                return <span style={{ color: 'red' }}>Blocked</span>
            } else if (text === 1) {
                return <span style={{ color: 'green' }}>Active</span>
            } else if (text === 2) {
                return <span style={{ color: 'red' }}>Disable</span>
            } else if (text === 4) {
                return <span style={{ color: 'red' }}>Terminated</span>
            }
        }
    }];

    handleRowSelection = () => {
        /*let { selectedRowKeys, tabData } = this.state;
        if (tabData !== "All") {
            return {
                selectedRowKeys,
                onChange: this.onSelectChange,
            };
        }*/
        return false;
    }

    handleExchangStatus = () => {
        var _this = this;
        this.setState({loading: true})
        let { tabData, selectedRowKeys } = this.state;
        let detailId = sessionManager.getMerchantId()
        let submitData = { tabData, counterList: selectedRowKeys, detailId };
        post(api.changeWalletStatus, submitData).then(function (response) {
            if (response !== selectedRowKeys.length) {
                notification['warning']({
                    message: response.errmsg,
                });
            }else{
                notification['success']({
                    message: "Successfully changed",
                });
            }
            _this.handleSearch()
        }).catch(function (error) {
            console.log(error)
            notification['error']({
                message: error.errmsg,
            });
            _this.setState({loading: false})
        })
    }

    componentDidMount() {
        this.setState({ tabData: "All" })
    }

    render() {
        const { selectedRowKeys, allNum, activeNum, data, total, loading, tabData } = this.state;
        return (
            <div style={{ width: "100%" }}>

                {/* //TODO:content */}
                <Descriptions contentStyle={{ textAlign: 'center' }} >
                    <Descriptions.Item labelStyle={{ fontSize: '22px', textAlign: 'center' }} contentStyle={{ fontWeight: 'bold', fontSize: '22px', textAlign: 'center' }} label="All"><span>{allNum}</span></Descriptions.Item>
                    <Descriptions.Item labelStyle={{ fontSize: '22px', textAlign: 'center' }} contentStyle={{ fontWeight: 'bold', fontSize: '22px', textAlign: 'center' }} label="Active Counters"><span>{activeNum}</span></Descriptions.Item>
                    <Descriptions.Item labelStyle={{ fontSize: '22px', textAlign: 'center' }} contentStyle={{ fontWeight: 'bold', fontSize: '22px', textAlign: 'center' }} label="Blocked Counters"><span>{allNum - activeNum}</span></Descriptions.Item>
                </Descriptions>

                <div style={{ marginTop: "20px" }}>
                    <Tabs style={{ marginBottom: "-17px", paddingLeft: '15px', border: '1px solid #ffffff', borderBottom: '0px' }} size="large" defaultActiveKey="All" onChange={this.handleChangeTab}>
                        <TabPane tab="All" key="All" />
                        <TabPane tab="Blocked" key="Blocked" />
                        <TabPane tab="Active" key="Active" />
                    </Tabs>
                    <Table
                        rowSelection={this.handleRowSelection()}
                        scrollToFirstRowOnChange={true}
                        scroll={{ x: '100%', y: 360 }}
                        columns={this.columns}
                        rowKey={record => record.userKey}
                        dataSource={data}
                        loading={loading} 
                        pagination={<Pagination style={{ marginTop: '5px' }} total={total} />}
                        />              
                </div>
                <div style={{ marginTop: "20px", display: "flex", justifyContent: "space-between", height: "30px" }}>
                    {tabData != "All" && 
                    <div >
                        <Button type="primary" style={{display:'none'}} >Cancel</Button>
                        <Button type="primary" style={{ marginLeft: "15px", display:'none' }}>Void</Button>
                    </div>}
                    {tabData !== "All" &&
                        <Button type="primary"  style={{display:'none'}} disabled={selectedRowKeys.length === 0} onClick={this.handleExchangStatus} >Change</Button>
                    }
                </div>
            </div>)
    }
}

export default CounterMgt;